import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subscription-banner-start',
  templateUrl: './subscription-banner-start.component.html',
  styleUrls: ['./subscription-banner-start.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerStartComponent {

  public dialogRef = inject(MatDialogRef<SubscriptionBannerStartComponent>);

  
}
